import { render, staticRenderFns } from "./AdminUserMenu.vue?vue&type=template&id=11900af8"
import script from "./AdminUserMenu.vue?vue&type=script&lang=ts"
export * from "./AdminUserMenu.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports